import { useEffect, useRef, useState } from "react";

/**
 * @deprecated Use useScrollDetectionV2 instead
 */
export const useScrollDetection = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleContentScroll = (event: Event) => {
      const target = event.target as HTMLDivElement;
      setIsScrolled(target.scrollTop > 0);
    };

    const contentElement = ref.current;
    if (contentElement) {
      contentElement.addEventListener("scroll", handleContentScroll);
      return () => {
        contentElement.removeEventListener("scroll", handleContentScroll);
      };
    }
  }, []);

  return { isScrolled, ref };
};
